import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useAdyen } from '../../../../../../context/Adyen/context.js';
import '../../../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import { useValidateShippingData } from '../utility-hooks/use-validate-shipping-data.js';
import { useTransactionInfo } from './use-transaction-info.js';

var ref;
const getRegularConfig = ({ locale , cartPrices , transactionInfo , currency , country , onAuthorized , onClick  }, config, merchantName)=>{
    var ref6, ref1, ref2, ref3, ref4, ref5;
    return swcHelpers.objectSpread({
        buttonLocale: locale,
        buttonType: 'pay',
        buttonSizeMode: 'fill',
        allowedAuthMethods: config === null || config === void 0 ? void 0 : (ref6 = config.googlepay) === null || ref6 === void 0 ? void 0 : ref6.allowedAuthMethods,
        allowedCardNetworks: config === null || config === void 0 ? void 0 : (ref1 = config.googlepay) === null || ref1 === void 0 ? void 0 : ref1.allowedCardNetworks,
        amount: {
            value: (ref = cartPrices === null || cartPrices === void 0 ? void 0 : cartPrices.totalPrice) !== null && ref !== void 0 ? ref : 0,
            currency
        },
        type: 'paywithgoogle',
        countryCode: country,
        transactionInfo,
        onAuthorized: (paymentData)=>{
            onAuthorized === null || onAuthorized === void 0 ? void 0 : onAuthorized(paymentData);
        }
    }, onClick ? {
        onClick
    } : {}, {
        isExpress: false
    }, (config === null || config === void 0 ? void 0 : (ref2 = config.googlepay) === null || ref2 === void 0 ? void 0 : ref2.environment) === 'PRODUCTION' && {
        environment: config === null || config === void 0 ? void 0 : (ref3 = config.googlepay) === null || ref3 === void 0 ? void 0 : ref3.environment,
        configuration: {
            gatewayMerchantId: merchantName,
            merchantId: config === null || config === void 0 ? void 0 : (ref4 = config.googlepay) === null || ref4 === void 0 ? void 0 : ref4.merchantId,
            merchantName: config === null || config === void 0 ? void 0 : (ref5 = config.googlepay) === null || ref5 === void 0 ? void 0 : ref5.merchantName
        }
    });
};
const getExpressConfig = ({ locale , cartPrices , transactionInfo , currency , country , onAuthorized , validateShippingData , shippingAddressRequired  }, config, merchantName)=>{
    var ref13, ref7, ref8, ref9, ref10, ref11;
    var ref12;
    const expressConfigWithoutShippingAddress = swcHelpers.objectSpread({
        buttonLocale: locale,
        buttonType: 'checkout',
        buttonSizeMode: 'fill',
        allowedAuthMethods: config === null || config === void 0 ? void 0 : (ref13 = config.googlepay) === null || ref13 === void 0 ? void 0 : ref13.allowedAuthMethods,
        allowedCardNetworks: config === null || config === void 0 ? void 0 : (ref7 = config.googlepay) === null || ref7 === void 0 ? void 0 : ref7.allowedCardNetworks,
        amount: {
            value: (ref12 = cartPrices === null || cartPrices === void 0 ? void 0 : cartPrices.totalPrice) !== null && ref12 !== void 0 ? ref12 : 0,
            currency
        },
        type: 'googlepay',
        countryCode: country,
        transactionInfo,
        isExpress: false,
        emailRequired: true,
        billingAddressRequired: true,
        billingAddressParameters: {
            format: 'FULL',
            phoneNumberRequired: true
        },
        shippingAddressParameters: {
            allowedCountryCodes: [
                country
            ],
            phoneNumberRequired: true
        },
        shippingOptionRequired: false,
        onAuthorized: (paymentData)=>{
            onAuthorized === null || onAuthorized === void 0 ? void 0 : onAuthorized(paymentData);
        }
    }, (config === null || config === void 0 ? void 0 : (ref8 = config.googlepay) === null || ref8 === void 0 ? void 0 : ref8.environment) === 'PRODUCTION' && {
        environment: config === null || config === void 0 ? void 0 : (ref9 = config.googlepay) === null || ref9 === void 0 ? void 0 : ref9.environment,
        configuration: {
            gatewayMerchantId: merchantName,
            merchantId: config === null || config === void 0 ? void 0 : (ref10 = config.googlepay) === null || ref10 === void 0 ? void 0 : ref10.merchantId,
            merchantName: config === null || config === void 0 ? void 0 : (ref11 = config.googlepay) === null || ref11 === void 0 ? void 0 : ref11.merchantName
        }
    });
    return shippingAddressRequired ? swcHelpers.objectSpread({}, expressConfigWithoutShippingAddress, {
        callbackIntents: [
            'SHIPPING_ADDRESS',
            'PAYMENT_AUTHORIZATION'
        ],
        shippingAddressRequired: true,
        paymentDataCallbacks: {
            onPaymentDataChanged (intermediatePaymentData) {
                return new Promise((resolve)=>{
                    const { callbackTrigger , shippingAddress  } = intermediatePaymentData;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const paymentDataRequestUpdate = {};
                    if (callbackTrigger === 'SHIPPING_ADDRESS' && validateShippingData) {
                        const { isPaymentDataValid , error  } = validateShippingData(shippingAddress);
                        if (!isPaymentDataValid) {
                            paymentDataRequestUpdate.error = error;
                        }
                    }
                    resolve(paymentDataRequestUpdate);
                });
            },
            onPaymentAuthorized (intermediatePaymentData) {
                return new Promise((resolve)=>{
                    const { shippingAddress  } = intermediatePaymentData;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const paymentDataRequestUpdate = {};
                    if (validateShippingData) {
                        const { isPaymentDataValid , error  } = validateShippingData(shippingAddress);
                        if (!isPaymentDataValid) {
                            paymentDataRequestUpdate.error = error;
                            paymentDataRequestUpdate.transactionState = 'ERROR';
                        }
                    }
                    paymentDataRequestUpdate.transactionState = 'SUCCESS';
                    resolve(paymentDataRequestUpdate);
                });
            }
        }
    }) : expressConfigWithoutShippingAddress;
};
const useGooglePayConfig = (props)=>{
    const { config , merchantName =''  } = useAdyen();
    const [mapTransactionInfo] = useTransactionInfo();
    const validateShippingData = useValidateShippingData();
    const propsRef = React.useRef(props);
    React.useEffect(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const regularGooglePayConfig = ()=>{
        const { cartPrices , lineItems , currency , country  } = propsRef.current;
        const transactionInfo = mapTransactionInfo({
            cartPrices,
            lineItems,
            currency,
            country
        });
        return getRegularConfig(swcHelpers.objectSpread({}, propsRef.current, {
            transactionInfo
        }), config, merchantName);
    };
    const expressGooglePayConfig = (shippingAddressRequired = false)=>{
        const { cartPrices , lineItems , currency , country  } = propsRef.current;
        const transactionInfo = mapTransactionInfo({
            cartPrices,
            lineItems,
            currency,
            country
        });
        return getExpressConfig(swcHelpers.objectSpread({}, propsRef.current, {
            cartPrices: propsRef.current.cartPrices,
            transactionInfo,
            validateShippingData,
            shippingAddressRequired
        }), config, merchantName);
    };
    return {
        regularGooglePayConfig,
        expressGooglePayConfig
    };
};

export { useGooglePayConfig };
//# sourceMappingURL=use-google-pay-config.js.map
